import React from 'react';
import { BrowserRouter as Router } from 'react-router';
import { ToastProvider } from '../shared/ui/feedback/ToastContext';
import { ServerErrorProvider } from '../shared/ui/feedback/ServerErrorOverlay';
import { ServerErrorBridge } from '../shared/ui/feedback/ServerErrorBridge';
import { OrganizationProvider } from '../features/organization/OrganizationContext';
import AppShell from './layout/AppShell';

function App() {
  return (
    <ServerErrorProvider>
      <OrganizationProvider>
        <ToastProvider>
          {/* v7_startTransition / v7_relativeSplatPath are just the default behavior in v7 --
              the opt-in `future` flags were a v6-only migration mechanism. */}
          <Router>
            <ServerErrorBridge />
            <AppShell />
          </Router>
        </ToastProvider>
      </OrganizationProvider>
    </ServerErrorProvider>
  );
}

export default App;
